export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const UPDATE_CONTENT = 'UPDATE_CONTENT';

export const openDialog = config => ({ type: OPEN_DIALOG, config });

export const updateContent = config => ({ type: UPDATE_CONTENT, config });

export const closeDialog = () => ({ type: CLOSE_DIALOG });
